import React, { FC, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, Plus } from "lucide-react";

import { SortingState } from "@tanstack/react-table";
import { NO_DATA } from "../../../../../assets";
import TableComponent from "../../../../../shared/components/table";
import { SearchResultColumns } from "../../../../../shared/components/table/columns/searchResult";

const SearchResult: FC = () => {
  const [hasData, setHasData] = useState(false);
  const navigate = useNavigate();
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");

  const mockData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      status: "Awaiting Submission",
      details: "View",
      query_status: "——",
      payment: "——",
      appeal_number: "——",
    },
  ];

  return (
    <div className="flex flex-col h-full  min-h-screen">
      {/* Header */}
      <div className="bg-white px-8 py-6 border-b border-[#E9EAEB] flex items-center justify-between">
        <h1 className="text-2xl font-bold text-[#1A1A1A]">Search result</h1>
      </div>

      {/* Breadcrumb & Search */}
      <div className="px-8 py-4 flex flex-col gap-y-6">
        <div className="flex items-center gap-x-2 text-sm text-[#464255]">
          <Link
            to="/private-individual/case-folders"
            className="hover:text-[#00B074]"
          >
            Home
          </Link>
          <span>&gt;</span>
          <span className="font-medium text-[#1A1A1A]">Search result</span>
        </div>

        <div className="relative w-full max-w-[300px]">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#E9EAEB] focus:outline-none focus:border-[#00B074] bg-white text-sm"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9A9A9A]" />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 px-8 pb-8">
        {hasData ? (
          // Empty State
          <div className="flex flex-col items-center justify-center h-[60vh] gap-y-2">
            <img src={NO_DATA} alt="No Data" className="w-[200px] h-[200px]" />
            <span className="text-[#464255] font-medium text-lg">
              No Result found
            </span>
          </div>
        ) : (
          // List State
          <div className="bg-white rounded-xl ">
            <TableComponent
              DATA={mockData}
              // @ts-ignore
              COLUMNS={SearchResultColumns}
              sorting={sorting}
              setSorting={setSorting}
            />

            {/* Pagination Mockup */}
            <div className="flex items-center justify-end gap-x-4 mt-6 text-sm text-[#464255]">
              <span>Page 1 of 10</span>
              <div className="flex items-center gap-x-2">
                <button className="px-3 py-1.5 border border-[#E9EAEB] rounded hover:bg-gray-50">
                  Previous
                </button>
                <button className="px-3 py-1.5 border border-[#E9EAEB] rounded hover:bg-gray-50">
                  Next
                </button>
              </div>
              <div className="flex items-center gap-x-2">
                <span>Entries per page:</span>
                <select className="border border-[#E9EAEB] rounded p-1 focus:outline-none">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                </select>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResult;
